import { Check, Copy } from 'lucide-react'

import { useCopyToClipboard } from '@/frontend/hooks/use-copy-to-clipboard'
import { cn } from '@/frontend/lib/utils'

export function Copyable({
  value,
  label = value,
  className,
}: {
  value: string
  label?: string
  className?: string
}) {
  const { copied, copy } = useCopyToClipboard()

  return (
    <button
      type="button"
      onClick={() => copy(value, label)}
      aria-label={`Copy ${label}`}
      className={cn(
        'group/copyable inline-flex min-w-0 items-center gap-1 rounded px-0.5 text-left hover:cursor-pointer focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
        className
      )}
    >
      <span className="truncate">{value}</span>
      {copied ? (
        <Check className="size-2.5 shrink-0 text-success-fg transition-transform group-hover/copyable:scale-120" />
      ) : (
        <Copy className="size-2.5 shrink-0 transition-transform group-hover/copyable:scale-120" />
      )}
    </button>
  )
}
